export default __webpack_public_path__ + "static/media/address.6367d001.svg";